export class DataStore {
    constructor() {
        this.data = {
            schools: []
        };
    }
}
